import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

interface PlatformSetting {
  key: string
  value: string
  description: string
  data_type: 'numeric' | 'integer' | 'boolean' | 'text'
  updated_at: string
}

export function usePlatformSettings() {
  return useQuery({
    queryKey: ['platform_settings'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_all_platform_settings')
      if (error) throw error
      return (data ?? []) as PlatformSetting[]
    },
    staleTime: 5 * 60 * 1000,
  })
}

export function usePlatformSetting(key: string) {
  return useQuery({
    queryKey: ['platform_setting', key],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_platform_setting', { p_key: key })
      if (error) throw error
      const row = Array.isArray(data) ? data[0] : data
      return row ?? null
    },
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * Helper: retorna true se maintenance_mode = 'true' nos platform_settings.
 * Útil para verificações rápidas sem depender de dois hooks separados.
 */
export function useMaintenanceMode(): boolean {
  const { data } = usePlatformSetting('maintenance_mode')
  return data?.value === 'true'
}
